import { render, staticRenderFns } from "./SendEgiftPanelRecipientsBulkOptions.vue?vue&type=template&id=06352ea3&scoped=true"
import script from "./SendEgiftPanelRecipientsBulkOptions.vue?vue&type=script&lang=ts"
export * from "./SendEgiftPanelRecipientsBulkOptions.vue?vue&type=script&lang=ts"
import style0 from "./SendEgiftPanelRecipientsBulkOptions.vue?vue&type=style&index=0&id=06352ea3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06352ea3",
  null
  
)

export default component.exports